import { render, staticRenderFns } from "./Decisions.vue?vue&type=template&id=7ba7d020&"
import script from "./Decisions.vue?vue&type=script&lang=js&"
export * from "./Decisions.vue?vue&type=script&lang=js&"
import style0 from "./Decisions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports